// Client contacts in the order the opportunity forms list them: alphabetical by
// the name the dropdown shows (first name, then last name). The API returns the
// primary contact first, which suits the Clients page but not a picker.
export function contactLabel(c) {
  return `${c?.first_name || ''} ${c?.last_name || ''}`.trim();
}

export function sortContactsByName(contacts) {
  return [...(contacts || [])].sort((a, b) =>
    contactLabel(a).localeCompare(contactLabel(b), 'en-GB', { sensitivity: 'base' }));
}

// A contact marked non-commercial works with us on delivery but does not see
// prices. A SOW names a commercial contact and, optionally, a non-commercial
// one, and each dropdown offers only the matching contacts. The contact already
// chosen is always kept, so re-marking somebody never empties a saved SOW.
export const isNonCommercial = (c) => !!Number(c?.is_non_commercial);

export function contactOptions(contacts, { nonCommercial, selectedId, excludeId } = {}) {
  return sortContactsByName(contacts).filter(c =>
    c.id === selectedId || (c.id !== excludeId && isNonCommercial(c) === !!nonCommercial));
}

// The option text: name, email, and a tag when a kept contact sits in the other
// list from the one they are marked for.
export function contactOptionText(c, { nonCommercial } = {}) {
  const tag = isNonCommercial(c) === !!nonCommercial ? '' : (isNonCommercial(c) ? ' (non-commercial)' : ' (commercial)');
  return `${contactLabel(c)}${c.email ? ` — ${c.email}` : ''}${tag}`;
}
